fragment image on AssetInterface {
    id
    url @transform (width: 1920, immediately: true)
    url_lg: url @transform (width: 1280, immediately: true)
    url_md: url @transform (width: 800, immediately: true)
    url_sm: url @transform (width: 600, immediately: true)
    url_xs: url @transform (width: 320, immediately: true)
    url_tiny: url @transform (width: 32, immediately: true)
    width
    height
    ... on media_Asset {
        alt
        title
        hasFocalPoint
        focalPoint
    }
}
